import React from "react";
import { Col, Row } from "reactstrap";
import { version } from "../../config";

const Footer = () => (
  <footer>
    <Row className="justify-content-between text-center fs--1 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          &copy; {new Date().getFullYear()} Copyright Sikka Software Corporation. All Rights Reserved | Leading AI infrastructure as a Service (AIaaS) for Retail Healthcare
        </p>
      </Col>
      <Col sm="auto">
        <p className="mb-0 text-600">Sikka API Portal v{version}</p>
      </Col>
    </Row>
  </footer>
);

export default Footer;
